import { render, staticRenderFns } from "./APITab.vue?vue&type=template&id=37403dc8&scoped=true&"
import script from "./APITab.vue?vue&type=script&lang=ts&"
export * from "./APITab.vue?vue&type=script&lang=ts&"
import style0 from "./APITab.vue?vue&type=style&index=0&id=37403dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37403dc8",
  null
  
)

export default component.exports